import log from '@/logger'
import config from '@/config'

const detectBrand = () => {
  const { hostname } = window.location
  log.info('brand.hostname', hostname)
  // special case for winplus brand
  if (hostname === 'www.winplus.co.uk') {
    return 'winplus'
  }
  if (hostname === 'winplus.mygoldmusic.co.uk') {
    return 'goldradiouk'
  }
  const found = hostname.match(/^winplus\.([a-z]+)\./)
  if (found && found.length === 2) {
    const [, brandCode] = found
    log.info('brand.detected-as', brandCode)
    return brandCode
  }
  return null
}

const BRANDS = config.BRANDS
const BRAND_CODE = detectBrand()

export { BRANDS, BRAND_CODE }
